registerComponent("demo/hero", function (component) {
const cta = component.querySelector('[data-hero-cta]');
const message = component.querySelector('[data-hero-message]');

cta?.addEventListener('click', () => {
    message?.removeAttribute('hidden');
});

});
